
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/talent-strategy-framework",
      function () {
        return require("private-next-pages/us/talent-strategy-framework/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/talent-strategy-framework"])
      });
    }
  